<div style="text-align:center;" *ngIf="traditionalGrades.length == 0 && isBusy == false" translate>
    No Grades exist for this student.
</div>

<div *ngIf="traditionalGrades != undefined">
    <div *ngFor="let grades of traditionalGrades">
        <div *ngIf="studentEnrollment != undefined">
            <div *ngIf="traditionalGrades.length > 1 && grades.SchoolName != studentEnrollment.SchoolName"
                style="padding-top:20px;">
                <b style="font-size: 12pt;padding-bottom:5px; margin-top:20px;">
                    {{grades.SchoolName}}
                </b>
            </div>

            <mat-table #table multiTemplateDataRows [dataSource]="grades.AngularMatData" tabindex="0"
                aria-label="Student Schedule Traditional Data Table" style="display: grid; overflow: auto;">
                <ng-container matColumnDef="More" sticky>
                    <mat-header-cell *matHeaderCellDef
                        style="min-width:68px;max-width:68px;text-align:center; position: sticky; left:0px;"
                        class="print-ignore">
                        <span translate>More</span></mat-header-cell>
                    <mat-cell *matCellDef="let ss"
                        style="min-width:68px;max-width:68px;text-align:center; position: sticky; left:0px;"
                        class="print-ignore">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(ss) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                                aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Meets" sticky>
                    <mat-header-cell *matHeaderCellDef style="min-width:125px;"><span translate>Meets</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let ss" style="min-width:125px;" [attr.tylerastid] = "'tblCell-' + ss.Meets">{{ss.Meets}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Term" sticky>
                    <mat-header-cell *matHeaderCellDef style="min-width:125px;"><span translate>Term</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let ss" style="min-width:125px;" [attr.tylerastid] = "'tblCell-' + ss.Term">{{ss.Term}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Course" sticky>
                    <mat-header-cell *matHeaderCellDef style="min-width:125px;"><span translate>Course Name</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let ss" style="min-width:125px;" [attr.tylerastid] = "'tblCell-' + ss.Term">{{ss.Course}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Teacher">
                    <mat-header-cell *matHeaderCellDef style="min-width:125px;"><span translate>Teacher</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let ss" style="min-width:125px;" [attr.tylerastid] = "'tblCell-' + ss.Teacher">{{ss.Teacher}}</mat-cell>
                </ng-container>
                <ng-container *ngFor="let term of grades.Terms" [matColumnDef]="term.GradingTerm">
                    <mat-header-cell *matHeaderCellDef style="min-width:80px;justify-content:center;">
                        <span style="text-align:center;" *ngIf="term.OverrideGradingTerm == null" [attr.tylerastid] = "'tblCell-' + term.GradingTerm">{{term.GradingTerm}}</span>
                        <span style="text-align:center;" *ngIf="term.OverrideGradingTerm != null" [attr.tylerastid] = "'tblCell-' + term.OverrideGradingTerm">{{term.OverrideGradingTerm}}</span></mat-header-cell>
                    <mat-cell *matCellDef="let ss" style="min-width:80px;justify-content: center;" >
                        <div *ngFor="let termGrade of ss | traditionalGradesFilter:term.GradingTerm" style="white-space: nowrap;"
                            [ngClass]="{'gradesBackground': termGrade.IsGradeBookGrade == true && showAssignmentLink == true}">
                            <span (click)="commentsAndBehaviorMarksClick(ss, termGrade)"
                            [ngClass]="{'gradesLink': (((termGrade.IsGradeBookGrade == true || termGrade.IsGradeBookExists == true) && showAssignmentLink == true) || (termGrade.Comment != null && termGrade.Comment.length > 0) || (termGrade.Workhabits != null && termGrade.Workhabits.length > 0) || (termGrade.Citizenship != null && termGrade.Citizenship.length > 0) || (termGrade.GradingTermDescription != null && termGrade.GradingTermDescription.length > 0 && showAssignmentLink == true)) }">
                            <span [attr.tylerastid] = "'tblCell-' + termGrade.DisplayGrade"
                                [ngStyle]="{'color': ((((termGrade.IsGradeBookGrade == true || termGrade.IsGradeBookExists == true) && showAssignmentLink == true) || (termGrade.Comment != null && termGrade.Comment.length > 0) || (termGrade.Workhabits != null && termGrade.Workhabits.length > 0) || (termGrade.Citizenship != null && termGrade.Citizenship.length > 0)) || (termGrade.GradingTermDescription != null && termGrade.GradingTermDescription.length > 0 && showAssignmentLink == true)) ? 'blue' : 'black'}">
                                {{termGrade.DisplayGrade}}
                            </span>
                        </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                    <div mat-cell *matCellDef="let ss" style="width:100%;margin-left:40px;margin-right:10px;"
                        aria-label="Traditional Grades Details">
                        <div class="mat-detail-card">
                            <table style="width:100%" [attr.aria-label]="getAriaDetailRow(ss)">
                                <tr>
                                    <td rowspan="2">
                                        <div>
                                            <table>
                                                <tr>
                                                    <td style="color: #595959;" translate>Course-Section</td>
                                                    <td style="padding-left:5px;" [attr.tylerastid]="'nested-tblCell-' + ss.SubjectCode + '-' + ss.Section">{{ss.SubjectCode}}-{{ss.Section}}</td>
                                                </tr>
                                                <tr>
                                                    <td style="color: #595959;" translate>Credits Attempted/Earned</td>
                                                    <td style="padding-left:5px;" [attr.tylerastid]="'nested-tblCell-' + ss.CreditAttempted / ss.CreditEarned">
                                                        {{ss.CreditAttempted}}/{{ss.CreditEarned}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                    <td style="min-width:60%">
                                        <div>
                                            <table style="width:60%;">
                                                <tr>
                                                    <td style="padding: 0px 10px;" *ngIf="showAssignmentLink" [attr.tylerastid]="'nested-tblCell-Assignments'">
                                                        <a (click)="viewAssignments(ss,undefined)"
                                                            translate>Assignments</a>
                                                    </td>
                                                    <td style="padding: 0px 10px;" *ngIf="showAttendanceLink" [attr.tylerastid]="'nested-tblCell-Attendance'">
                                                        <a (click)="viewAttendance(ss)" translate>Attendance</a>
                                                    </td>
                                                    <td style="padding: 0px 10px;" *ngIf="showSendEmailLink" [attr.tylerastid]="'nested-tblCell-Email Teacher'">
                                                        <a (click)="sendEmail(ss)" translate>Email Teacher</a>
                                                    </td>
                                                    <td style="padding: 0px 10px;" [attr.tylerastid]="'nested-tblCell-Course / Teacher Info'">
                                                        <a *ngIf="(enableClassInfoTeacherProfiles && (ss.HasClassProfile || ss.HasTeacherProfile))" [matMenuTriggerFor]="courseTeacherInfo.menu" translate>Course
                                                            / Teacher Info</a>
                                                        <tyl-general-mat-menu #courseTeacherInfo="menuTrigger">
                                                            <button mat-menu-item *ngIf="enableClassInfoTeacherProfiles && ss.HasClassProfile"
                                                                (click)="actionMenuClick('Class Information', ss)">
                                                                <span translate>Class Information</span>
                                                            </button>
                                                            <button mat-menu-item *ngIf="enableClassInfoTeacherProfiles && ss.HasTeacherProfile"
                                                                (click)="actionMenuClick('Teacher Profile', ss)">
                                                                <span translate>Teacher Profile</span>
                                                            </button>
                                                        </tyl-general-mat-menu>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>

                                <!-- Category Scores -->
                                <tr *ngIf="showCategoryScores(ss)">
                                    <td colspan="2">
                                        <div style="color:black; font-weight:bold; padding-top:5px;" translate>Category
                                        </div>
                                        <div style="padding-left:25px; padding-top:5px;">
                                            <table style="border:thin solid lightgray; width:600px;">
                                                <tr>
                                                    <th style="padding-left:10px;" translate>
                                                        Name
                                                    </th>
                                                    <th style="padding-left:10px;" translate>
                                                        Weight
                                                    </th>
                                                    <th *ngFor="let term of ss.CategoriesTerms.terms"
                                                        style="padding-left:10px;">
                                                        {{term.Name}}
                                                    </th>
                                                </tr>
                                                <tr *ngFor="let category of ss.CategoriesTerms.categories">
                                                    <td style="padding-left:10px;">
                                                        {{category.Name}}
                                                    </td>
                                                    <td style="padding-left:10px;">
                                                        {{category.Weight}}%
                                                    </td>
                                                    <td *ngFor="let term of ss.CategoriesTerms.terms"
                                                        style="padding-left:10px;">
                                                        {{getCategoryAverage(ss, category, term)}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <!-- Category Scores End -->

                            </table>
                        </div>
                    </div>
                </ng-container>

                <mat-header-row *matHeaderRowDef="getColumnsToDisplay(grades.Terms, grades.SiteYearId)"></mat-header-row>
                <mat-row *matRowDef="let row; columns: getColumnsToDisplay(grades.Terms, grades.SiteYearId);" matRipple tabindex="0"
                    (click)="toggleExpanded(row)" [attr.aria-label]="getAriaRow(row, grades.Terms)"></mat-row>
                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                    [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"></mat-row>
            </mat-table>
        </div>
    </div>
</div>
